import './Switch.less';

import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useReframe } from 'nike-re-framejs';
import { isSubmitting, makeField } from 'nike-form-js';

interface SwitchProps {
    active: boolean;
    readOnly?: boolean;
    onClick: Function;
    otherClassName?: string;
    activeClassName?: string;
    noActiveClassName?: string;
    enabled?: boolean;
    small?: boolean;
    dataAtid?: string;
    throttlingDelay?: number;
}

type FormSwitchProps = Partial<SwitchProps> & {
    form?: any;
    path?: string[];
};

export const FormSwitch = ({ form, path, onClick, ...rest }: FormSwitchProps) => {
    const { deref } = useReframe();
    const field = form && makeField(form, path),
        // isTouched = deref(field.isTouched()),
        // errors = deref(field.getErrors()),
        // isError = isTouched && errors.size > 0,
        submitting = deref(isSubmitting(form)),
        value = deref(field.getValue());
    return (
        <>
            <Switch
                active={value}
                onClick={() => {
                    if (!submitting) {
                        field.setValue(!value);
                        onClick && onClick();
                    }
                }}
                {...rest}
            />
        </>
    );
};

export const Switch = ({
    active,
    readOnly,
    onClick,
    otherClassName = '',
    activeClassName = '',
    noActiveClassName = '',
    enabled = true,
    dataAtid = '',
    throttlingDelay
}: SwitchProps) => {
    //TODO move to useThrottlingDelay hook, return [click, isDelayed]
    const [delayTimeout, setDelayTimeout] = useState<number>();
    const click = e => {
        if (throttlingDelay) {
            if (delayTimeout) {
                return;
            }
            setDelayTimeout(
                (setTimeout(() => {
                    setDelayTimeout(null);
                }, throttlingDelay) as unknown) as number
            );
        }
        onClick(e);
    };
    useEffect(
        () => () => {
            clearTimeout(delayTimeout);
        },
        [delayTimeout]
    );
    return (
        <div
            className={clsx(
                'nui-toggle-switch d-inline-block p-rel',
                {
                    'nui-toggle-switch-disabled': !enabled || delayTimeout,
                    [`active ${activeClassName}`]: active,
                    [noActiveClassName]: !active
                },
                otherClassName
            )}
            data-atid={dataAtid}
            onClick={e => {
                if (enabled) {
                    return !readOnly ? click(e) : e.preventDefault();
                }
            }}
        />
    );
};
